// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICalculateScheduleRequestDto } from './ICalculateScheduleRequestDto';
import {
    ICalculateScheduleRequestDtoFromJSON,
    ICalculateScheduleRequestDtoFromJSONTyped,
    ICalculateScheduleRequestDtoToJSON,
    ICalculateScheduleRequestDtoToJSONTyped,
} from './ICalculateScheduleRequestDto';

/**
 * 
 * @export
 * @interface IPayrollCalendarRequestDto
 */
export interface IPayrollCalendarRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarRequestDto
     */
    calendar_name: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarRequestDto
     */
    frequency_type: IPayrollCalendarRequestDtoFrequencyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarRequestDto
     */
    group_type: IPayrollCalendarRequestDtoGroupTypeEnum;
    /**
     * 
     * @type {ICalculateScheduleRequestDto}
     * @memberof IPayrollCalendarRequestDto
     */
    calculate_schedule_request_dto: ICalculateScheduleRequestDto;
    /**
     * 
     * @type {Set<Date>}
     * @memberof IPayrollCalendarRequestDto
     */
    scheduled_dates: Set<Date>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarRequestDto
     */
    plan_ids?: Set<number>;
    /**
     * 
     * @type {Set<number>}
     * @memberof IPayrollCalendarRequestDto
     */
    payroll_group_ids?: Set<number>;
    /**
     * 
     * @type {number}
     * @memberof IPayrollCalendarRequestDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollCalendarRequestDto
     */
    organization_path: string;
}

/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarRequestDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IPayrollCalendarRequestDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IPayrollCalendarRequestDto interface.
 */
export function instanceOfIPayrollCalendarRequestDto(value: object): value is IPayrollCalendarRequestDto {
    if (!('calendar_name' in value) || value['calendar_name'] === undefined) return false;
    if (!('frequency_type' in value) || value['frequency_type'] === undefined) return false;
    if (!('group_type' in value) || value['group_type'] === undefined) return false;
    if (!('calculate_schedule_request_dto' in value) || value['calculate_schedule_request_dto'] === undefined) return false;
    if (!('scheduled_dates' in value) || value['scheduled_dates'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('organization_path' in value) || value['organization_path'] === undefined) return false;
    return true;
}

export function IPayrollCalendarRequestDtoFromJSON(json: any): IPayrollCalendarRequestDto {
    return IPayrollCalendarRequestDtoFromJSONTyped(json, false);
}

export function IPayrollCalendarRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollCalendarRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_name': json['calendar_name'],
        'frequency_type': json['frequency_type'],
        'group_type': json['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoFromJSON(json['calculate_schedule_request_dto']),
        'scheduled_dates': new Set(json['scheduled_dates']),
        'plan_ids': json['plan_ids'] == null ? undefined : new Set(json['plan_ids']),
        'payroll_group_ids': json['payroll_group_ids'] == null ? undefined : new Set(json['payroll_group_ids']),
        'organization_id': json['organization_id'],
        'organization_path': json['organization_path'],
    };
}

export function IPayrollCalendarRequestDtoToJSON(json: any): IPayrollCalendarRequestDto {
    return IPayrollCalendarRequestDtoToJSONTyped(json, false);
}

export function IPayrollCalendarRequestDtoToJSONTyped(value?: IPayrollCalendarRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendar_name': value['calendar_name'],
        'frequency_type': value['frequency_type'],
        'group_type': value['group_type'],
        'calculate_schedule_request_dto': ICalculateScheduleRequestDtoToJSON(value['calculate_schedule_request_dto']),
        'scheduled_dates': Array.from(value['scheduled_dates'] as Set<any>),
        'plan_ids': value['plan_ids'] == null ? undefined : Array.from(value['plan_ids'] as Set<any>),
        'payroll_group_ids': value['payroll_group_ids'] == null ? undefined : Array.from(value['payroll_group_ids'] as Set<any>),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

